export default {
  pageTitle: '部落格',
  pageSubtitle: '專業的寵物照護技巧和指南',
  searchPlaceholder: '搜尋文章...',
  categories: {
    all: '全部文章',
    health: '健康',
    nutrition: '營養',
    training: '訓練',
    grooming: '美容',
    lifestyle: '生活',
    news: '新聞'
  },
  sortNewest: '最新優先',
  sortOldest: '最舊優先',
  readMore: '閱讀文章',
  minutesRead: '分鐘閱讀',
  noArticlesFound: '找不到文章',
  noArticlesDescription: '試著調整搜尋或篩選條件',
  clearFilters: '清除所有篩選',
  backToBlog: '返回部落格',
  shareArticle: '分享',
  relatedArticles: '相關文章',
  tags: '標籤',
  featured: '精選',
  article: '文章',
  articles: '文章',
  showing: '顯示',
  tableOfContents: '目錄'
};